"use strict";

exports.__esModule = true;
exports.StyledSeparator = void 0;

var _styled = require("@manifest-ui/styled");

const StyledSeparator = (0, _styled.styled)('hr', {
  themeKey: 'separator'
})({
  alignSelf: 'stretch',
  backgroundColor: 'border',
  border: 'none',
  borderWidth: 'medium',
  margin: 0,
  overflow: 'visible',
  ['&[data-orientation=horizontal]']: {
    height: '1px',
    width: 'auto'
  },
  ['&[data-orientation=vertical]']: {
    height: 'auto',
    width: '1px'
  }
});
exports.StyledSeparator = StyledSeparator;